// extracted by mini-css-extract-plugin
export var container = "_o2-0";
export var dotAnimation = "_o2-2";
export var dotsLoading = "_o2-1";